export const initialState = () => ({
  uuid: null,
  currentStep: 0,
  isEditing: false,
  role: {
    name: "",
    level: null,
    searchable: null,
    category: "",
    active: false,
    accessControl: null,
    canSell: null,
    accessWithoutGeolocation: null,
  },
  permissions: [],
  menuPermissions: [],
  homePermissions: [],
  permissionsOptions: [],
  menuPermissionsOptions: [],
  homePermissionsOptions: [],
  reportPermissionsOptions: []
})
